import { Component } from '@angular/core';

@Component({
  selector: 'app-mess-link',
  templateUrl: './mess-link.component.html',
  styleUrls: ['./mess-link.component.scss']
})
export class MessLinkComponent {

}
